import translator from '@/locales';

export class AbortedError extends Error {
  constructor() {
    super(translator.t('ABORTED_ERROR'));
    this.isAborted = true;
  }
}

export class ApiError extends Error {
  constructor({ body, status }) {
    const { message, ...otherBodyData } = body;
    super(message);
    this.status = status;
    Object.assign(this, otherBodyData);
  }
}

export default function({
  message = translator.t('UNKNOWN_ERROR'),
  status,
  body,
}) {
  if (status === 0) throw new AbortedError();
  if (body && typeof body === 'object') throw new ApiError({ status, body });
  throw new Error(message);
}
